import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import AppToggleField, { type AppToggleOption } from "../form/AppToggleField";

type Props = {
  /** Optional uppercase-style section caption above the toggle group. */
  label?: string;
  value: string;
  options: AppToggleOption[];
  disabled?: boolean;
  onChange: (value: string) => void;
  helperText?: ReactNode;
};

/**
 * Standard exclusive choice for settings forms (LLM mode, OpenSearch mode, etc.).
 * Wraps AppToggleField — prefer over ad-hoc contained/outlined AppButton groups.
 */
export default function FormChoiceGroup({
  label,
  value,
  options,
  disabled,
  onChange,
  helperText,
}: Props) {
  return (
    <Box sx={{ width: "100%" }}>
      <AppToggleField label={label} value={value} options={options} disabled={disabled} onChange={onChange} />
      {helperText ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.75 }}>
          {helperText}
        </Typography>
      ) : null}
    </Box>
  );
}
